module.exports = __webpack_public_path__ + "static/media/sk.1da1c0ab.svg";